import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';
import { map, take } from 'rxjs/operators';
import { User } from '../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class SuccessCenterGuard  {
    constructor(
        private readonly userService: UserService,
        private readonly authenticationService: AuthenticationService,
    ) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.userService.getUserData().pipe(
            take(1),
            map((user: User | null) => {
                if (!user) {
                    this.authenticationService.navigateToMainPage();
                    return false;
                }

                const isAllowed = user.is_admin && user.account_type === 5;
                if (!isAllowed) {
                    this.authenticationService.navigateToMainPage();
                }
                return isAllowed;
            }),
        );
    }
}
